module.exports = __webpack_public_path__ + "static/media/default.3b015e70.svg";